import React, { useState } from 'react';
import { CLIENT_STATUSES, FREQUENCY_OPTIONS } from '../data/clientMaster';

export default function ClientSetup({ clients, clientMaster, onUpdate, onClose }) {
  const [search, setSearch] = useState('');
  

  const filtered = clients.filter(c =>
    !search || c.name.toLowerCase().includes(search.toLowerCase())
  );

  const ClientRow = ({ client }) => {
    const master = clientMaster[client.name] || {};
    const [editing, setEditing] = useState(false);
    const [form, setForm] = useState({
      responsible: master.responsible || '',
      phone: master.phone || '',
      clientStatus: master.clientStatus || 'active',
      expectedFrequency: master.expectedFrequency || 'monthly',
      notes: master.notes || '',
    });

    const save = () => {
      onUpdate(client.name, form);
      setEditing(false);
    };

    return (
      <div className={`setup-row ${editing ? 'editing' : ''}`}>
        <div className="setup-row-header" onClick={() => setEditing(!editing)}>
          <div className="setup-client-info">
            <span className="setup-client-name">{client.name}</span>
            <div className="setup-client-meta">
              {master.responsible && <span className="meta-tag">{master.responsible}</span>}
              {master.clientStatus && (
                <span className="meta-tag" style={{
                  background: CLIENT_STATUSES.find(s => s.value === master.clientStatus)?.color + '22',
                  color: CLIENT_STATUSES.find(s => s.value === master.clientStatus)?.color,
                }}>
                  {CLIENT_STATUSES.find(s => s.value === master.clientStatus)?.label}
                </span>
              )}
              {client.totalJobs > 0 && <span className="meta-tag grey">{client.totalJobs} jobs in file</span>}
            </div>
          </div>
          <div className="setup-row-status">
            {!master.responsible && !master.clientStatus && (
              <span className="setup-incomplete">⚠ Not configured</span>
            )}
            <span className="setup-expand">{editing ? '▲' : '▼'}</span>
          </div>
        </div>

        {editing && (
          <div className="setup-form">
            <div className="form-grid">
              <div className="form-field">
                <label>Responsible Person</label>
                <input
                  type="text"
                  value={form.responsible}
                  onChange={e => setForm(f => ({ ...f, responsible: e.target.value }))}
                  placeholder="Name or team"
                />
              </div>
              <div className="form-field">
                <label>Phone / WhatsApp</label>
                <input
                  type="text"
                  value={form.phone}
                  onChange={e => setForm(f => ({ ...f, phone: e.target.value }))}
                  placeholder="+971..."
                />
              </div>
              <div className="form-field">
                <label>Client Status</label>
                <select
                  value={form.clientStatus}
                  onChange={e => setForm(f => ({ ...f, clientStatus: e.target.value }))}
                >
                  {CLIENT_STATUSES.map(s => (
                    <option key={s.value} value={s.value}>{s.label}</option>
                  ))}
                </select>
              </div>
              <div className="form-field">
                <label>Expected Job Frequency</label>
                <select
                  value={form.expectedFrequency}
                  onChange={e => setForm(f => ({ ...f, expectedFrequency: e.target.value }))}
                >
                  {FREQUENCY_OPTIONS.map(o => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </select>
              </div>
              <div className="form-field full-width">
                <label>Notes</label>
                <textarea
                  value={form.notes}
                  onChange={e => setForm(f => ({ ...f, notes: e.target.value }))}
                  placeholder="e.g. Symbion — Madagascar project done, next expected Q4 2026"
                  rows={2}
                />
              </div>
            </div>
            <div className="form-actions">
              <button className="btn-primary small" onClick={save}>Save</button>
              <button className="btn-secondary small" onClick={() => setEditing(false)}>Cancel</button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const unconfigured = clients.filter(c => !clientMaster[c.name]?.responsible).length;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal large" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <h2>Client Configuration</h2>
            {unconfigured > 0 && (
              <p className="modal-subtitle">
                {unconfigured} client{unconfigured !== 1 ? 's' : ''} not yet configured
              </p>
            )}
          </div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          <input
            className="search-input full-width"
            placeholder="Search clients..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />

          <div className="setup-list">
            {/* Show unconfigured first */}
            {filtered
              .sort((a, b) => {
                const aConf = !!clientMaster[a.name]?.responsible;
                const bConf = !!clientMaster[b.name]?.responsible;
                if (aConf !== bConf) return aConf ? 1 : -1;
                return b.attentionScore - a.attentionScore;
              })
              .map(client => (
                <ClientRow key={client.name} client={client} />
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}
